import React from 'react';

import DocumentsTable from 'components/shared/DocumentsTable/DocumentsTable';

export default function ChartDocuments() {
  const options = {
    enableDocumentEdit: true,
    enableDocumentMarkup: true,
    enableDocumentSharing: true,
    enableAppointmentLinking: true,
    showImportantDocuments: true,
    showSendPatientForms: true,
    enableSendAsFax: true,
    enableCheckboxSelection: true,
    enableTags: true
  };

  return <DocumentsTable level="chart" options={options} />;
}
